import _defineProperty from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { animateBackdrop } from '@tesla/design-system';
import cx from 'classnames';
import React, { useEffect, useRef } from 'react';
export var SiteHeader = function SiteHeader(_ref) {
  var _cx;

  var animated = _ref.animated,
      children = _ref.children,
      className = _ref.className,
      fadeIn = _ref.fadeIn,
      headerRef = _ref.headerRef,
      sticky = _ref.sticky,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["animated", "children", "className", "fadeIn", "headerRef", "sticky", "variant"]);

  var fallbackRef = useRef(null);
  var ref = headerRef || fallbackRef;
  useEffect(function () {
    if (ref.current && animated) {
      var cleanup = animateBackdrop(ref.current);
      return cleanup;
    }

    return;
  }, [children, animated, ref]);
  return React.createElement("header", _objectSpread({
    className: cx('tds-site-header', (_cx = {}, _defineProperty(_cx, "tds-site-header--".concat(variant), variant), _defineProperty(_cx, 'tds--fade-in', fadeIn), _defineProperty(_cx, 'tds-site-header--sticky', sticky), _cx), className),
    id: "tds-site-header",
    ref: ref
  }, rest), animated && React.createElement("div", {
    className: "tds-animate--backdrop-backdrop"
  }), children);
};